import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "src/Utils/Context/UserContext";
import { CircularLoader } from "src/design/CircularLoader";
import { colorTextPrimary, colorTextMuted } from "src/design/tokens";
import { isOrganizationViewEnabled } from "src/helpers/FeatureCapabilityConfig";
import { SubscriptionCard } from "./components/SubscriptionCard";
import { AccountDetailsCard } from "./components/AccountDetailsCard";
import { PasswordSecurityCard } from "./components/PasswordSecurityCard";

const Configuration = () => {
  const { t } = useTranslation();
  const { user, isLoading } = useContext(UserContext);
  const { restaurantId } = useParams<{ restaurantId: string }>();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularLoader />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        width: "100%",
        maxWidth: 900,
        mx: "auto",
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700, color: colorTextPrimary }}>
          {t("configuration.pageTitle")}
        </Typography>
        <Typography variant="body1" sx={{ color: colorTextMuted }}>
          {t("configuration.pageSubtitle")}
        </Typography>
      </Box>

      {isOrganizationViewEnabled(user) && (
        <SubscriptionCard restaurantId={restaurantId ?? ""} />
      )}
      <AccountDetailsCard />
      <PasswordSecurityCard />
    </Box>
  );
};

export default Configuration;
